import Automotive from "assets/images/document-translation/automotive.svg";
import Banking from "assets/images/document-translation/banking.svg";
import Gaming from "assets/images/document-translation/gaming.svg";
import Government from "assets/images/document-translation/government.svg";
import Healthcare from "assets/images/document-translation/healthcare.svg";
import hiTech from "assets/images/document-translation/hi-tech.svg";
import legal from "assets/images/document-translation/legal.svg";
import luxury from "assets/images/document-translation/luxury.svg";
import military from "assets/images/document-translation/military.svg";

export const Data = [
    {
      FirstWhite:"Over",  
      title: "Documents Translated Professionally",
      ColorHead: "1,000,000",
      detail:
        "Since our inception, we have been providing translation in document services for over a decade. We have translated numerous documents, using a combination of premiere technological tools and smart human solutions. Our technology can translate huge volumes of documents on-demand, while our translators make sure your every translation is a quality one.",
    },
    {
      FirstWhite:"Confidence of Over",
      title: "Businessess",
      ColorHead: "95,000",
      detail: "Tomedes ranks among the leading providers of document translation services in the world. Business clients from startups to Fortune 50 corporations rely on us to translate their documents in more than 200 language combinations. Our official document translation services are comprehensive in nature but tailored to your needs.",
    },
    {
      FirstWhite:"",
      title: "Document Translation Services in 120+ Languages",
      ColorHead: "Professional",
      detail:
        "Tomedes directs a global team of document translation specialists, in over 100 countries across five continents. Our expert linguists have skills in every major language and each major industry. That diversity of coverage guarantees that our translations are targeted accurately and comprehensively to the readers you intend to reach. Your intended meaning is never lost in translation.",
      link: " ",
    },
    {
      FirstWhite:"",
      title: " for public and private institutions",
      ColorHead: "Guaranteed",
      detail:
        "All your document translations are guaranteed for public and private institutions, by our offer of a 1-year guarantee on all translations of documents. This is a sure-fire way to ensure your document translators and the service they provide are up to par.",
    },
    {
      FirstWhite:"",
      title: "document translation services",
      ColorHead: "ISO certified",
      detail:
        "Our translation of documents is highly certified, through ISO certification, ensuring the highest quality in your document translations. Our professional document translation services go through a two-step process of quality assurance as well.",
    },
   
  ];
  
  export const MoreData = [
    {
      title: "Legal",
      subTitle:"Document Translation Services",
      detail:
        "Tomedes excels at translating legal documents. Serving officers of the courts and law firms is our expertise. Legally trained linguists ensure that documents conform to the expectations of authorities and requirements of the law.",
      link: "/legal-translation.php",

    },
    {
      title: "Certified",
      subTitle:"Document Translation Services",
      detail:
        "Document certification is another core specialization of our translation services. Our linguists are trained to translate documents, certifying translation accuracy that passes muster with authorities in jurisdictions across the globe.",
      link: "/certified-translation.php",
    },
    {
      title: "Financial",
      subTitle:"Document Translation Services",
      detail:
        "Your financial documents need to be translated with a professional document translation service, in order to ensure the highest level of detail and accuracy for your important documents such as cash flow statements, income statements, and balance sheets.",
      link: "/financial-translation.php",
    },
    {
      title: "Medical",
      subTitle:"Document Translation Services",
      detail:
        "Accurate translation of medical documents can be a matter of life and death. We ensure that each such assignment is handled by trained and certified linguists familiar with the terminology of pharmacology and medicine",
      link: "/medical-translation.php",
    },
    {
      title: "Technical",
      subTitle:"Document Translation Services",
      detail:
        "Translation of technical documents is a requirement for virtually every business and scientific project, for customer support. Tomedes ensures that experts familiar with the technical jargon of your industry are on your translation team.",
      link: "/technical-translation.php",
    },
  ];
  


  export const CardData = [
    {
      head: "Automotive",
      image: Automotive,
      content:
        "Tomedes places its automotive clients in the driver seat, assigning document translation teams with expertise in the language of the auto industry in target countries, fine-tuned for distributors, dealers, and drivers.",
        link: "/industries/automotive",
    },
    {
      head: "Banking & Finance",
      image: Banking,
      subTitle:"Document Translation Services",
      content:
        "Translating documents for finance-related clients requires extreme exactitude. Tomedes linguists command decades of expertise in the terminology of financial services industries, delivering translations that are “right on the money.”",
        link: "/industries/banking-finance",
    },
    {
      head: "Healthcare",
      image: Healthcare,
      content:
        "Getting the words right in health and medical matters saves time, money, and lives. Healthcare providers and medical product companies rely on Tomedes for linguistic expertise in medicine and pharmaceuticals.",
        link: "/industries/healthcare",
    },
    {
      head: "Gaming",
      subTitle:"Document Translation Services",
      image: Gaming,
      content:
        "Games are not child's play. They're a big business: Tomedes translators bring expert know-how of game documentation to deliver perfect translations of the technical documents and marketing collateral our global gaming clients require.",
        link: "/industries/gaming",
    },
    {
      head: "High-Tech",
      image: hiTech,
      content:
        "Our tech-savvy translators command expertise in the translation of technical, marketing, and sales documents as well as in-depth experience in localizing the documentation of websites, applications, and other software.",
        link: "/industries/technology",
    },
    {
      head: "Military",
      subTitle:"Document Translation Services",
      image: military,
      content:
        "Tomedes serves agencies in the public and private security sectors worldwide. Our military-trained linguistic teams combine technical expertise in document translation with a strict commitment to confidentiality, ensuring that our work hits the target.",
        link: "/industries/military",
    },
    {
      head: "Government",
      image: Government,
      content:
        "Bureaucratese is a language unto itself, not easy to translate, but Tomedes translators bring their expertise to serve the document translation needs of the public sector and NGOs with accuracy and discretion.",
        link: "/industries/government",
    },
    {
      head: "Luxury Brands",
      subTitle:"Document Translation Services",
      image: luxury,
      content:
        "Luxury brands hold high standards for the language of their sales and marketing collateral. Tomedes brings global expertise to localizing documents for discriminating clients, translating brand value across linguistic borders.",
        link: "/industries/luxury-brands",
    },
    {
      head: "Legal Services",
      subTitle:"Document Translation Services",
      image: legal,
      content:
        "Tomedes supervises a worldwide team of linguists with legal expertise, sensitive to the subtleties of every turn of phrase. Fastidious care in document translation is a requirement when serving officers of the court.",
        link: "/industries/legal-services",
    },
   
  ];


  

  export const FaqData = [
    {
      FirstWhite:"How do we",  
      title: "your document translator?",
      ColorHead: "select",
      borderLine: " ",
      detail:
        "Document translators are screened using a rigorous two-step process. Tomedes uses a combination of human reviewers and QA tools to assess the linguistic and industry-specific expertise of each applicant. Their work is continuously audited via our internal review system which takes a number of factors into account including client feedback, professionalism, and consistency.",
    },
    {
      FirstWhite:"How do we",  
      title: "your documents?",
      ColorHead: "certify",
      borderLine: " ",
      detail:
        "Tomedes translation agency is certified to provide document translation services faithful to the original document. This means that certified translators will provide authentic representations of the original texts. Tomedes is certified by the American Translator's Association to provide these services. At Tomedes, we can assist in all aspects of your application to help broaden your horizons.",
    },
    {
      FirstWhite:"Can you",  
      title: "your documents online?",
      ColorHead: "send",
      borderLine: " ",
      detail:
        "You can send your documents online through a variety of methods: through email, through our quote process, through the WhatsApp link above, and through the contact form, or file upload form on this page.",
    },  {
      FirstWhite:"Which file",  
      title: "should you send your documents in?",
      ColorHead: "format",
      borderLine: " ",
      detail:
        "Feel free to send your documents in the file formats of .doc, .docx, .pdf, .xml, .html, .csv, .xlsx, and .txt. We usually deal with these file formats, but you can also send image files such .png, .jpeg, and .svg. If you're in need, simply send us your documents in the file format you prefer.",
    },  {
      FirstWhite:"Do we use",  
      title: "engines?",
      ColorHead: "machine translation",
      detail:
        "Our primary method of translation is through the honed skillsets of professional document translators. However, our machine translation post-editing services are available upon request. It's ideal for a project of large volumes of documents and is done with the expertise of official post-editors, to ensure the highest quality and accuracy.",
    },
  ]